import { useTranslation } from 'react-i18next';
import { Zap } from 'lucide-react';
import { useWorkspace } from '@/workspace/WorkspaceContext';
import { Badge } from '@/components/ui/badge';
import { CacheTab } from '@/components/organization/CacheTab';

export function Cache(): JSX.Element {
  const { t } = useTranslation();
  const { currentBotId, currentBot } = useWorkspace();

  if (!currentBotId) {
    return (
      <div className="rounded-md border border-dashed p-8 text-center text-sm text-muted-foreground">
        {t('cachePage.selectBot', {
          defaultValue:
            'Select a bot from the workspace switcher to configure its response cache.',
        })}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <header className="flex items-center gap-3">
        <Zap className="h-6 w-6 text-primary" />
        <div>
          <h1 className="text-2xl font-semibold">
            {t('cachePage.title', { defaultValue: 'Cache' })}
          </h1>
          <p className="text-xs text-muted-foreground">
            {t('cachePage.subtitle', {
              defaultValue:
                'Serve an identical /diagnose or /support request to {{bot}} from a stored answer instead of calling the AI service again.',
              bot: currentBot?.name ?? currentBotId,
            })}
          </p>
        </div>
        {currentBot ? (
          <Badge variant="secondary" className="ml-auto font-mono">
            {currentBotId}
          </Badge>
        ) : null}
      </header>
      <CacheTab />
    </div>
  );
}
